import { defineMessages } from 'react-intl';

export default defineMessages({
    notice: {
        id: 'companyDirectorNotice',
        defaultMessage:
            'Notice: To be able to apply you will need to be director of {companyName}.'
    }
});
